import { useRef, useCallback } from 'react';
import { HistoryManager, UpdateNodesCommand, UpdatePrefabsListCommand, CompositeCommand } from '../history.js';

export const useHistory = () => {
  const historyManager = useRef(new HistoryManager());

  const executeCommand = useCallback((command) => {
    historyManager.current.execute(command);
  }, []);

  const recordCommand = useCallback((command) => {
    historyManager.current.record(command);
  }, []);

  const undo = useCallback(() => {
    historyManager.current.undo();
  }, []);

  const redo = useCallback(() => {
    historyManager.current.redo();
  }, []);

  const clear = useCallback(() => {
    historyManager.current.clear();
  }, []);

  const createUpdateNodesCommand = useCallback((targetPrefabId, oldNodes, newNodes, oldSelection, newSelection, handlers) => {
    return new UpdateNodesCommand(targetPrefabId, oldNodes, newNodes, oldSelection, newSelection, handlers);
  }, []);

  const createUpdatePrefabsCommand = useCallback((oldPrefabs, newPrefabs, oldSelection, newSelection, handlers) => {
    return new UpdatePrefabsListCommand(oldPrefabs, newPrefabs, oldSelection, newSelection, handlers);
  }, []);

  const createCompositeCommand = useCallback((commands) => {
    return new CompositeCommand(commands);
  }, []);

  return {
    executeCommand,
    recordCommand,
    undo,
    redo,
    clear,
    createUpdateNodesCommand,
    createUpdatePrefabsCommand,
    createCompositeCommand
  };
};
